__turbopack_context__.v({
  "chatstickerblock": "ChatStickerBlock-module-sass-module__tOftiG__chatstickerblock",
  "chatstickerblock--animated": "ChatStickerBlock-module-sass-module__tOftiG__chatstickerblock--animated",
  "chatstickerblock--editable": "ChatStickerBlock-module-sass-module__tOftiG__chatstickerblock--editable",
  "chatstickerblock__animation--in": "ChatStickerBlock-module-sass-module__tOftiG__chatstickerblock__animation--in",
  "chatstickerblock__bubble": "ChatStickerBlock-module-sass-module__tOftiG__chatstickerblock__bubble",
  "chatstickerblock__bubble__animation--in": "ChatStickerBlock-module-sass-module__tOftiG__chatstickerblock__bubble__animation--in",
  "chatstickerblock__bubble__image": "ChatStickerBlock-module-sass-module__tOftiG__chatstickerblock__bubble__image",
});
